module.exports = __webpack_public_path__ + "static/media/snackbar_v2_error.6d1cc9d0.svg";